/* eslint-disable react/prop-types */
import React, { useEffect, useRef } from 'react';
import { Html5QrcodeScanner } from 'html5-qrcode';

const qrcodeRegionId = 'html5qr-code-full-region';

const createConfig = props => {
  let config = {
    rememberLastUsedCamera: true,
    aspectRatio: 4 / 3,
    showTorchButtonIfSupported: true
  };
  if (props.fps) {
    config.fps = props.fps;
  }
  if (props.qrbox) {
    config.qrbox = props.qrbox;
  }
  if (props.aspectRatio) {
    config.aspectRatio = props.aspectRatio;
  }
  if (props.disableFlip !== undefined) {
    config.disableFlip = props.disableFlip;
  }
  return config;
};

const Html5QrcodePlugin = props => {
  const html5QrcodeScannerRef = useRef(null);
  const mainContainer = useRef(null);

  useEffect(() => {
    if (!html5QrcodeScannerRef.current) {
      const config = createConfig(props);
      const verbose = props.verbose === true;

      html5QrcodeScannerRef.current = new Html5QrcodeScanner(
        qrcodeRegionId,
        config,
        verbose
      );

      html5QrcodeScannerRef.current.render(
        props.qrCodeSuccessCallback,
        props.qrCodeErrorCallback
      );
    }

    if (props.qrScanned && html5QrcodeScannerRef.current) {
      const stopButton = document.getElementById(
        'html5-qrcode-button-camera-stop'
      );
      if (stopButton) {
        stopButton.click();
      }
      html5QrcodeScannerRef.current.clear().catch(error => {
        console.error('Failed to clear html5QrcodeScanner.', error);
      });
    }

    return () => {
      if (html5QrcodeScannerRef.current) {
        html5QrcodeScannerRef.current.clear().catch(error => {
          console.error('Failed to clear html5QrcodeScanner.', error);
        });
        html5QrcodeScannerRef.current = null;
      }
    };
  }, [props.qrScanned]);

  return <div ref={mainContainer} id={qrcodeRegionId} />;
};

export default Html5QrcodePlugin;
